export function cidFromSource(source) {
  if (!/^cid:/i.test(String(source || '').trim())) return null;
  try { return decodeURIComponent(String(source).trim().slice(4)); } catch { return null; }
}
